export default __webpack_public_path__ + "9c8988edff11622ddd8ceeadb095a551.svg";